import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useLoginAs } from '@hooks/security/use-login-as';

const LoginAs = () => {
    const [searchParams] = useSearchParams();
    const { redeem, error } = useLoginAs(searchParams.get('token') ?? '');

    // The token is single-use, so a second POST would fail and replace the session message with an error.
    const hasRedeemed = useRef(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        if (hasRedeemed.current) return;

        hasRedeemed.current = true;

        redeem().then((result) => setIsLoggedIn(result.ok));
    }, [redeem]);

    if (error) {
        return (
            <div className='container'>
                <div className='alert alert-danger'>{error}</div>
            </div>
        );
    }

    if (!isLoggedIn) return null;

    return (
        <div className='container'>
            <div className='alert alert-info'>
                <h4>We logged you in as the user for support assistance</h4>
                <p>The session lasts for a maximum of 2 hours.</p>
                <p>
                    <Link className='btn btn-primary' to='/register/donate'>
                        Continue
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default LoginAs;
